export default {
  methods: {
    createLoanModel(screenLoanData) {
      let saveLoanModel = Object.assign({}, screenLoanData);
      delete saveLoanModel["regex"];
      delete saveLoanModel["date"];
      delete saveLoanModel["text"];
      delete saveLoanModel["profileName"];
      delete saveLoanModel["amount"];
      delete saveLoanModel["tagName"];
      delete saveLoanModel["name"];
      delete saveLoanModel["entityName"];
      delete saveLoanModel["factOutstandingBalance"];
      delete saveLoanModel["isFromFact"];
      delete saveLoanModel["durationType"];
      delete saveLoanModel["loanTypeName"];
      delete saveLoanModel["clientName"];
      delete saveLoanModel["userdurationType"];
      delete saveLoanModel["Interest"];
      delete saveLoanModel["isFactDataChanges"];
      delete saveLoanModel["ErrorText"];
      delete saveLoanModel["IsError"];
      return saveLoanModel;
    },
  },
};
